import { ChangeDetectorRef, Component, OnDestroy } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { CommonModule, formatDate } from '@angular/common';
import { MatChipsModule } from '@angular/material/chips';
import { ReactiveFormsModule, FormsModule, FormGroup, FormBuilder, FormArray, Validators, FormControl } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatRadioModule } from '@angular/material/radio';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule, MAT_DATE_FORMATS, MAT_DATE_LOCALE, DateAdapter, NativeDateAdapter } from '@angular/material/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';
import { GlobalVariablesService } from '../../global.service';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { SharedService } from '../../share-data/shared.service';
import { APIService } from '../../fleet-management/backend-service/backend-service';
import { HttpResponse } from '@angular/common/http';
import { NotificationService } from '../../shared/services/notification.service';
import { LoadingService } from '../../services/loading.service';
import { Subscription } from 'rxjs';


export const DATE_FORMATS = {
  parse: {
    dateInput: 'dd/MM/yyyy',
  },
  display: {
    dateInput: 'dd/MM/yyyy',
    monthYearLabel: 'MMM yyyy',
    dateA11yLabel: 'dd/MM/yyyy',
    monthYearA11yLabel: 'MMMM yyyy'
  }
};

@Injectable()
export class CustomDateAdapter extends NativeDateAdapter {
  override format(date: Date, displayFormat: Object): string {
    if (displayFormat === 'dd/MM/yyyy') {
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    }
    return super.format(date, displayFormat);
  }

  override parse(value: any): Date | null {
    if (typeof value === 'string' && value.includes('/')) {
      const parts = value.split('/');
      if (parts.length === 3) {
        const day = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10) - 1;
        const year = parseInt(parts[2], 10);
        return new Date(year, month, day);
      }
    }
    return super.parse(value);
  }
}

@Component({
  selector: 'app-user-registration',
  imports: [
    ReactiveFormsModule,
    FormsModule,
    MatCheckboxModule,
    MatInputModule,
    CommonModule,
    MatChipsModule,
    MatSelectModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    MatIconModule,
    MatRadioModule,
    MatDatepickerModule,
    MatNativeDateModule,
    RouterLink,
    MatProgressSpinnerModule
  ],
  providers: [
    DatePipe,
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
    { provide: DateAdapter, useClass: CustomDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: DATE_FORMATS }
  ],
  templateUrl: './user-registration.component.html',
  styleUrl: './user-registration.component.scss'
})
export class UserRegistrationComponent implements OnDestroy {
  khmerName: string = '';
  englishName: string = '';

  NIDNumber: string = '';
  genderOption: string[] = ['Male', 'Female'];
  selectedGender: string = this.genderOption[0];
  userRoleOption: any[] = [];
  userRolerSelect: any = { roleCode: '', name: '' }; // Default value
  selectedNIDPic!: File;
  selectedProfile!: File;
  // selectedProfile: File[] = [];
  formattedDate: string = '';
  dateControl = new FormControl();
  displayDate = new FormControl(''); // Holds formatted string
  email: string = '';
  username: string = '';
  password: string = '';
  confirmPassword: string = '';
  hidePassword = true;
  userData: any;
  isEdit: string = '';
  isLoading: boolean = false;
  private loadingSubscription: Subscription;

  constructor(private datePipe: DatePipe, private globalVariable: GlobalVariablesService,
    private cdr: ChangeDetectorRef, private route: ActivatedRoute, private sharedService: SharedService,
    private apiService: APIService, private router: Router,
    private notification: NotificationService, public loadingService: LoadingService) {
    this.loadingSubscription = this.loadingService.isLoading$.subscribe(loading => this.isLoading = loading);
  }

  ngOnInit() {
    this.formattedDate = formatDate(new Date(), 'yyyy-MM-dd', 'en-US');
    this.setUserRoles();
    this.route.queryParams.subscribe(async params => {
      this.isEdit = params["isEdit"];
      if (this.isEdit == 'true') {
        try {
          this.userData = this.sharedService.getData();
          if (!this.userData) {
            const stored = sessionStorage.getItem('userEditData');
            if (stored) {
              this.userData = JSON.parse(stored);
              this.sharedService.setData(this.userData);
            }
          }
          console.log("Share data:", this.userData);
          this.khmerName = this.userData["khmerName"];
          this.englishName = this.userData["englishName"];
          this.selectedGender = this.userData["gender"];
          this.userRolerSelect = this.globalVariable.SETTING_USER_ROLES?.find((role: any) => role.roleCode === this.userData["roleCode"]) || { roleCode: '', name: '' };
          this.NIDNumber = this.userData["nidNumber"];
          this.email = this.userData["email"];
          this.username = this.userData["username"];

          this.formattedDate = this.datePipe.transform(this.userData["employmentDate"], 'yyyy-MM-dd')!;

          console.log("Date: ", this.formattedDate)

          const nidPic = this.userData["url"] + this.userData["nidPicture"];
          const nidName = this.userData["nidPicture"];
          const nidFile = await this.fetchImageAsFile(nidPic, nidName);
          this.selectedNIDPic = nidFile;

          const profilePic = this.userData["url"] + this.userData["profilePicture"];
          const profileName = this.userData["profilePicture"];
          const profileFile = await this.fetchImageAsFile(profilePic, profileName);
          this.selectedProfile = profileFile;



          this.cdr.detectChanges(); // Ensure changes are reflected
        } catch (error) {

        }
      }
    });


  }
  setUserRoles() {
    for (const role of this.globalVariable.SETTING_USER_ROLES || []) {
      if (!this.userRoleOption.some(r => r["roleCode"] === role.roleCode)) {
        this.userRoleOption.push(role);
      }
    }
  }

  onNIDSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files) {
      // this.selectedNIDPic = Array.from(input.files);
      this.selectedNIDPic = input.files[0];
    }
  }
  onProfileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files) {
      // this.selectedProfile = Array.from(input.files);
      this.selectedProfile = input.files[0];
    }
  }

  getImageUrl(file: File): string {
    return URL.createObjectURL(file);
  }
  async fetchImageAsFile(url: string, filename: string): Promise<File> {
    const response = await fetch(url);
    const blob = await response.blob();

    // Guessing MIME type from the file extension, fallback to 'image/jpeg'
    const mime = blob.type || 'image/jpeg';

    return new File([blob], filename, { type: mime });
  }

  onYearSelected(event: any) {
    if (event.value) {
      this.formattedDate = this.datePipe.transform(event.value, 'yyyy-MM-dd')!;
      console.log("Formatted: ", this.formattedDate)
    }
  }

  submitButtonAction() {
    let loginData = JSON.parse(localStorage.getItem('loginData')!)
    console.log("File: ", this.selectedNIDPic)
    if (this.khmerName.length < 1) {
      this.notification.warning('Please enter Khmer Name')
      return;
    }
    if (this.englishName.length < 1) {
      this.notification.warning('Please enter English Name')
      return;
    }
    if (this.NIDNumber.length < 5) {
      this.notification.warning('Please enter NID Number')
      return;
    }
    if (this.selectedGender.length < 1) {
      this.notification.warning('Please select gender')
      return;
    }
    if (!this.userRolerSelect.roleCode || this.userRolerSelect.roleCode.length < 1) {
      this.notification.warning('Please select User Role')
      return;
    }
    if (this.email.length < 1) {
      this.notification.warning('Please enter Email')
      return;
    }
    if (this.username.length < 1) {
      this.notification.warning('Please enter Username')
      return;
    }
    if (this.selectedNIDPic == null) {
      this.notification.warning('Please select NID Picture')
      return;
    }
    if (this.selectedProfile == null) {
      this.notification.warning('Please select Profile Picture')
      return;
    }
    let jsonData: any = {
      "khmerName": this.khmerName,
      "englishName": this.englishName,
      "username": this.username,
      "gender": this.selectedGender,
      "nidNumber": this.NIDNumber,
      "roleCode": this.userRolerSelect.roleCode,
      "employmentDate": this.formattedDate,
      "email": this.email,
      "nidPicture": this.selectedNIDPic,
      "profilePicture": this.selectedProfile
    }
    console.log("User data: ", jsonData)
    let endpoint = '';
    if (this.isEdit == 'true') {
      endpoint = '/api/users/' + this.userData["id"];
      this.apiService.putFormData(endpoint, jsonData, loginData.token)
        .subscribe({
          next: (response: HttpResponse<any>) => {
            console.log('HTTP Status:', response.status); // 👈 here you get status
            console.log('/api/users/edit' + ',\n' + 'Edit_Response:', response.body);

            if (response.status === 200) {
              this.notification.success('Update User successfully');
              sessionStorage.removeItem('userEditData');
            }
            else {
              this.notification.error('Update User failed. Please try again.');
            }
            this.router.navigate(['/home/user-management']);
          },
          error: err => {
            console.error('Error:', err);
          }
        });
    }
    else {
    jsonData["password"] = this.password;
    console.log("User data: ", jsonData)
      endpoint = '/api/users/register';
      this.apiService.postFormData(endpoint, jsonData, loginData.token).subscribe({
        next: response => {
          console.log('HTTP Status:', response.status); // 👈 Get status here
          console.log('Response Body:', response.body);
          if (response.status === 200 || response.status === 201) {
            this.notification.success('Register User successfully');
            sessionStorage.removeItem('userEditData');
          }
          else {
            this.notification.error('Register User failed. Please try again.');
          }
          this.router.navigate(['/home/user-management']);
        },
        error: error => {
          console.error('Error:', error);
        }
      });
    }
    console.log("endpoint: ", endpoint)

  }

  ngOnDestroy() {
    if (this.loadingSubscription) {
      this.loadingSubscription.unsubscribe();
    }
  }
}
